import { render, staticRenderFns } from "./PurchaseLead.html?vue&type=template&id=393cf78d&"
import script from "./PurchaseLead.js?vue&type=script&lang=js&"
export * from "./PurchaseLead.js?vue&type=script&lang=js&"
import style0 from "./PurchaseLead.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports